import script from "./WCAddToCartModernCardButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCAddToCartModernCardButton.vue?vue&type=script&setup=true&lang=ts"

import "./WCAddToCartModernCardButton.vue?vue&type=style&index=0&id=22898f8a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22898f8a"]])

export default __exports__